import { Link } from "react-router-dom";

export default function About() {
  return (
    <div data-testid="about-page" className="px-6 md:px-12 lg:px-24 py-24">
      <p className="label-eyebrow text-[#555]">— Journal</p>
      <h1 className="font-serif-display text-5xl md:text-7xl tracking-tighter leading-none font-light mt-4 max-w-4xl">
        Why we built <span className="italic text-[#1E3A8A]">AfricaArtMasters</span>
      </h1>
      <div className="grid grid-cols-12 gap-y-10 gap-x-4 lg:gap-10 mt-20">
        <div className="col-span-12 lg:col-span-3">
          <p className="label-eyebrow text-[#555]">N° 01 · Editorial</p>
          <p className="font-mono-aam text-xs text-[#555] mt-2">5 min read</p>
        </div>
        <div className="col-span-12 lg:col-span-7 space-y-6 text-lg text-[#333] leading-relaxed font-light">
          <p>
            For decades, contemporary African art has lived on the margins of the global market — present in
            biennales and museum catalogues, absent from the everyday spaces where collectors browse, discover,
            and buy. We thought that imbalance was overdue for correction.
          </p>
          <p>
            <span className="font-serif-display text-3xl italic text-[#1E3A8A]">&ldquo;The continent is not a genre.&rdquo;</span>
          </p>
          <p>
            AfricaArtMasters is a curated portal where masters working from Harare, Johannesburg, Lusaka, Nairobi,
            Johannesburg and beyond can place their works on the same wall as the rest of the world. No middlemen.
            No commissions disguised as gallery fees. Just artists, collectors, and the work that connects them.
          </p>
          <p>
            We take a 0% commission on every sale during our launch season. The full price reaches the artist.
            That is the manifesto. The rest is curation.
          </p>
          <Link
            to="/gallery"
            className="inline-block mt-8 label-eyebrow border border-[#111] px-8 py-4 hover:bg-[#111] hover:text-white transition-colors"
          >
            Enter the Gallery
          </Link>
        </div>
      </div>
    </div>
  );
}
